import DocumentsDetails from "../Documents/DocumentsDetails";
import { useGetTechicalDocumentsWrapper } from "src/Utils/Hooks/Downloads/useGetTechnicalDocumentsWrapper";
import { useTranslation } from "react-i18next";

const TechnicalDocuments = () => {
    const { t } = useTranslation();
    const { data } = useGetTechicalDocumentsWrapper();
    return (
        <>
            {data &&
                <>
                    <DocumentsDetails data={data} title={t('TechnicalDocumentation')} id="tech-doc" />
                </>
            }
        </>
    )
}
export default TechnicalDocuments;